import {GlobalConfig} from 'ngx-toastr';

export const AppToastrConfig: GlobalConfig = {
  includeTitleDuplicates: false,
  payload: undefined,
  autoDismiss: true,
  closeButton: true,
  countDuplicates: false,
  disableTimeOut: false,
  easeTime: 300,
  easing: 'ease-in-out',
  enableHtml: true,
  extendedTimeOut: 5000,
  iconClasses: {
    error: 'toast-error',
    info: 'toast-info',
    success: 'toast-success',
    warning: 'toast-warning'
  },
  maxOpened: 1,
  messageClass: 'toast-message',
  newestOnTop: true,
  onActivateTick: false,
  positionClass: 'toast-top-right',
  preventDuplicates: true,
  progressAnimation: 'decreasing',
  progressBar: true,
  resetTimeoutOnDuplicate: true,
  tapToDismiss: true,
  timeOut: 5000,
  titleClass: 'toast-title',
  toastClass: 'ngx-toastr'
};
